import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';

// TODO: implement actual page in #17087
import { jsx as _jsx } from "react/jsx-runtime";
function SessionDetailsPage(_ref) {
  var isNested = _ref.isNested,
    session = _ref.session;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Stack, {
    spacing: "m",
    children: /*#__PURE__*/_jsx(TitleCard, {
      title: t('Session details'),
      variant: "raised",
      headingLevel: isNested ? 'h3' : 'h2',
      children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
        horizontal: true,
        children: /*#__PURE__*/_jsx(FormStack, {
          spacing: "m",
          children: session.id
        })
      })
    })
  });
}
export default SessionDetailsPage;